import { QueryFunctionContext, useQuery } from 'react-query';
import { useHistory, useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

import { FullScheduleData } from '@common/types/api';
import { api } from '@services';

const fetchScheduleSession = async (
  ctx: QueryFunctionContext<[string, number, string]>,
) => {
  const [, sessionId] = ctx.queryKey;

  const response = await api.get<{ data: FullScheduleData }>(
    `/schedules/${sessionId}?include=participants,room`,
  );

  return response.data.data;
};

export const useScheduleSessionQuery = (id: number) => {
  const history = useHistory();
  const { search, ...location } = useLocation();
  const { i18n } = useTranslation();
  const currentLang = i18n.language || 'br';

  const queryParams = new URLSearchParams(search);

  return useQuery(['session', id, currentLang], fetchScheduleSession, {
    onError: () => {
      queryParams.delete('session');

      history.replace({
        ...location,
        search: `?${queryParams.toString()}`,
      });

      toast.error('Falha ao buscar os dados da sessão');
    },
  });
};
